import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk"; // ✅ Redux 5 me default export nahi hai
import rootReducer from "./reducer";

// ✅ Agar browser me Redux DevTools installed hai toh use karega
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
